import Swiper from 'swiper';
import { Navigation, Pagination, EffectCreative, Autoplay, Scrollbar, Grid } from 'swiper/modules';
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay, Scrollbar, Grid]);

const equipmentSlider = new Swiper('.testimonial-slider', {
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: ".testimonial-pagination",
  }
});
